import { Fragment, React, useState } from 'libs/react';
import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import { DealSearchList } from '../DealSearchList';
import './DealReplaceItemsModal.scss';
/**
 * Picks another deal whose products and options replace the ones of the
 * configured deal.
 *
 * @component DealReplaceItemsModal
 * @since 1.0.0
 */
export function DealReplaceItemsModal(props) {
    var _a, _b;
    const { deal, onClose, onConfirm, processing } = props;
    const [selectedDeal, setSelectedDeal] = useState(null);
    const otherCurrency = ((_a = selectedDeal === null || selectedDeal === void 0 ? void 0 : selectedDeal.currency) === null || _a === void 0 ? void 0 : _a.id) != null &&
        selectedDeal.currency.id !== ((_b = deal.currency) === null || _b === void 0 ? void 0 : _b.id);
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose }),
        React.createElement(Button, { style: "primary", label: t('Replace'), disabled: processing || !selectedDeal, onPress: () => selectedDeal && onConfirm(selectedDeal.id) })));
    return (React.createElement("div", { className: "deal-replace-items-modal" },
        React.createElement(Modal, { picto: "copy", title: t('Replace content'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "deal-replace-items-modal-content" },
                React.createElement("p", { className: "deal-replace-items-modal-infos" }, t('The products and options of this quote will be replaced by those of the selected deal. Save the quote to keep the changes.')),
                React.createElement(DealSearchList, { selected: selectedDeal, onSelect: setSelectedDeal, onConfirm: (selected) => onConfirm(selected.id), excludeId: deal.id, disabled: processing }),
                otherCurrency && (React.createElement("p", { className: "deal-replace-items-modal-warning" }, t('This deal uses another currency. Prices will be copied as is.')))))));
}
